"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortFunction = exports.sortObjectsByText = exports.sortObjectsByUserName = exports.sortObjectsByDate = exports.sortFoldersAndFiles = void 0;
var moment = require("moment");
var NUMERIC_SORT_ORDER = {
    asc: 1,
    desc: -1
};
var getMeta = function (item) {
    if (typeof item.customMeta === 'object') {
        return item.customMeta;
    }
    else {
        return item.customMeta.reduce(function (p, curr) {
            p[curr.identifier] = curr.value;
            return p;
        }, {});
    }
};
var sortFoldersAndFiles = function (meta) {
    return function (order) {
        return function (a, b) {
            if (a.type !== b.type) {
                if (a.type === 'FOLDER') {
                    return -1;
                }
                else if (b.type === 'FOLDER') {
                    return 1;
                }
            }
            var column = meta.id || meta.identifier;
            if (column === 'name-meta') {
                return order === 'desc'
                    ? b.name.localeCompare(a.name)
                    : a.name.localeCompare(b.name);
            }
            var al = getMeta(a);
            var bl = getMeta(b);
            if (meta.type === 'text') {
                var aValue = al[column] || a.name;
                var bValue = bl[column] || b.name;
                if (typeof aValue === 'string' && typeof bValue === 'string') {
                    return order === 'desc'
                        ? bValue.localeCompare(aValue)
                        : aValue.localeCompare(bValue);
                }
            }
            else if (meta.type === 'select') {
                var def = {
                    name: ''
                };
                var x1 = (meta.options || []).find(function (y) { return y.value === al[column]; }) || def;
                var x2 = (meta.options || []).find(function (y) { return y.value === bl[column]; }) || def;
                return order === 'desc'
                    ? "".concat(x2.name || '').localeCompare("".concat(x1.name || ''))
                    : "".concat(x1.name || '').localeCompare("".concat(x2.name || ''));
            }
            return al[column] < bl[column]
                ? order === 'asc'
                    ? 1
                    : -1
                : order === 'asc'
                    ? -1
                    : 1;
        };
    };
};
exports.sortFoldersAndFiles = sortFoldersAndFiles;
var sortObjectsByDate = function (inputArray, sortParams) {
    return Array.from(inputArray).sort(function (a, b) {
        var a2 = moment(a[sortParams.sortBy] || 0);
        var b2 = moment(b[sortParams.sortBy] || 0);
        return a2.diff(b2) * NUMERIC_SORT_ORDER[sortParams.sortOrder];
    });
};
exports.sortObjectsByDate = sortObjectsByDate;
var sortObjectsByUserName = function (inputArray, sortParams) {
    return Array.from(inputArray).sort(function (a, b) {
        var a2 = getUserName(a[sortParams.sortBy]);
        var b2 = getUserName(b[sortParams.sortBy]);
        return a2.localeCompare(b2) * NUMERIC_SORT_ORDER[sortParams.sortOrder];
    });
};
exports.sortObjectsByUserName = sortObjectsByUserName;
var getUserName = function (user) {
    if (user) {
        return user.firstName + ' ' + user.lastName;
    }
    else
        return '';
};
var sortObjectsByText = function (inputArray, sortParams) {
    return Array.from(inputArray).sort(function (a, b) {
        return ((a[sortParams.sortBy] || '').localeCompare(b[sortParams.sortBy] || '') *
            NUMERIC_SORT_ORDER[sortParams.sortOrder]);
    });
};
exports.sortObjectsByText = sortObjectsByText;
var getSortFunction = function (params) {
    return function (inputArray, sortParams) {
        if (params.dateFields.includes(sortParams.sortBy))
            return (0, exports.sortObjectsByDate)(inputArray, sortParams);
        if (params.userNameFields.includes(sortParams.sortBy))
            return (0, exports.sortObjectsByUserName)(inputArray, sortParams);
        if (params.textFields.includes(sortParams.sortBy))
            return (0, exports.sortObjectsByText)(inputArray, sortParams);
        return Array.from(inputArray);
    };
};
exports.getSortFunction = getSortFunction;
